import {
  Box,
  Chip,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { useTenants } from '@/api/hooks';
import { EmptyState, ErrorState, PageHeader } from '@/components/states';
import { formatDateTime } from '@/features/license-assignment/cellState';

export function TenantsPage() {
  const { data, isPending, error, refetch } = useTenants();

  return (
    <Box>
      <PageHeader
        title="Mandanten"
        description="Aus SEP importiert. Der Schlüssel gehört SEP und wird hier nie geändert."
      />
      {error && <ErrorState error={error} onRetry={() => void refetch()} />}

      {isPending ? (
        <Skeleton variant="rectangular" height={320} />
      ) : !data || data.length === 0 ? (
        <EmptyState
          title="Noch keine Mandanten"
          description="Synchronisieren Sie auf der Lizenzvergabe-Seite mit SEP."
        />
      ) : (
        <TableContainer component={Paper} variant="outlined" sx={{ overflowX: "auto" }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Mandant</TableCell>
                <TableCell>Schlüssel</TableCell>
                <TableCell align="right">Benutzer</TableCell>
                <TableCell align="right">Lizenzierte Apps</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Zuletzt synchronisiert</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((tenant) => (
                <TableRow key={tenant.key} hover>
                  <TableCell>{tenant.displayName}</TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      {tenant.key}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">{tenant.userCount}</TableCell>
                  <TableCell align="right">{tenant.licensedAppCount}</TableCell>
                  <TableCell>
                    <Chip
                      label={tenant.status === 'active' ? 'aktiv' : 'inaktiv'}
                      variant="outlined"
                      color={tenant.status === 'active' ? 'success' : 'default'}
                    />
                  </TableCell>
                  <TableCell>{formatDateTime(tenant.lastSyncedAt)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
